<div class="container-fluid mt-5 mb-5">
    <div class="row">
        <div class="col-md-10">
            <h1 class="small-30 new-font">Shopping Cart</h1>
        </div>
        <div class="col-md-2">
            <button *ngIf="cartData" (click)="onDeleteAllItem()" class="cancel-icon">Empty Cart</button>
        </div>
        <div class="col-md-12 mt-4">
            <div class="table-responsive">
                <table class="table w-100 cart-table table-bordered">
                    <tr class="bg-row">
                        <td>
                            Product
                        </td>
                        <td>
                            Description
                        </td>
                        <td *ngIf="is_hide_cost == null">
                            Price
                        </td>
                        <td>
                            Quantity
                        </td>
                        <td colspan="2">
                            Cart Total
                        </td>
                    </tr>
                    <tr *ngIf="!cartData">
                        <td colspan="5" class="text-center">Cart is Empty</td>
                    </tr>
                    <ng-template [ngIf]="cartData">
                        <ng-container *ngFor="let item of cartData.cart_items">
                        <tr>
                            <td>
                                <img [src]="item.product_variant.product.images | baseImage | imagePath" [alt]="item.product_variant.product.brand" class="img-fluid" style="width:150px" />
                            </td>
                            <td style="width: 30%">
                                <h2>
                                    {{ item.product_variant.product.brand.name }} - {{ item.product_variant.product.model.name }} {{ item.product_variant.product.finish.finish}}
                                </h2>
                                <h3>
                                    <span>Size</span> {{ item.product_variant.size }}
                                </h3>
                                <h3>
                                    <span>Bolt Pattern</span> {{ item.product_variant.bolt_pattern}} <ng-container *ngIf="item.bolt_pattern">{{ item.bolt_pattern == 'recommended' ? '(Recommended)' : '(Selected: ' + item.bolt_pattern + ')' }}</ng-container>
                                </h3>
                                <h3>
                                    <span>Offset</span> {{ item.product_variant.offset }} <ng-container *ngIf="item.offset">{{ item.offset === 'recommended' ? '(Recommended)' : '(Selected: ' + item.offset + ')' }}</ng-container>
                                </h3>
                                <h3>
                                    <span>Part Number: </span> {{ item.product_variant.sku }}
                                </h3>
                                <h3 *ngIf="item.vehicle_year_make_model">
                                    <span>Vehicle Year Make Model: </span> {{ item.vehicle_year_make_model }}
                                </h3>
                            </td>
                            <td *ngIf="is_hide_cost == null">
                                <p *ngIf="item.sale_price <= 0" [ngClass]="isSameVendor(item) ? 'line-through mb-0' : ''">
                                    {{ item.product_variant.us_retail_price | currency: item?.product_variant.product?.vendor?.currency:'symbol'}}
                                </p>
                                <p *ngIf="item.sale_price > 0" [ngClass]="isSameVendor(item) ? 'line-through mb-0' : ''">
                                    {{ item.sale_price | currency: item?.product_variant.product?.vendor?.currency:'symbol'}}
                                </p>
                                <p *ngIf="isSameVendor(item)"> {{ 0 | currency: item?.product_variant.product?.vendor?.currency:'symbol' }} (Own Product) </p>
                            </td>
                            <td>
                                <div class="quinty-box" *ngFor="let warehouseQty of item.warehouse_quantity">
                                    <p>{{ warehouseQty.ware_house.warehouse_name }}</p>
                                    <div class="input-group custom-adder custom-adder-rw">
                                        <input type="button" value="-" class="button-minus" data-field="quantity" (click)="onChangeWarehouseQuantity(item.cart_id, warehouseQty, 'minus')">
                                        <input type="number" step="1" min="1" [value]="warehouseQty.quantity" name="quantity" class="quantity-field" (input)="updateQuantity(item.cart_id, warehouseQty, $event)">
                                        <input type="button" value="+" class="button-plus" data-field="quantity" (click)="onChangeWarehouseQuantity(item.cart_id, warehouseQty, 'plus')">
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span *ngIf="is_hide_cost == null" [ngClass]="isSameVendor(item) ? 'line-through' : ''">
                                    {{ item.sale_price*item.quantity | currency: item?.product_variant.product?.vendor?.currency:'symbol' }}
                                </span>
                                <span *ngIf="is_hide_cost != null && item.product_variant.sale_price == null" [ngClass]="isSameVendor(item) ? 'line-through' : ''">
                                    {{ item.price*item.quantity | currency: item?.product_variant.product?.vendor?.currency:'symbol' }}
                                </span>
                                <span *ngIf="is_hide_cost != null && item.product_variant.sale_price != null" [ngClass]="isSameVendor(item) ? 'line-through' : ''">
                                    {{ item.product_variant.sale_price*item.quantity | currency: item?.product_variant.product?.vendor?.currency:'symbol' }}
                                </span> <br>
                                <span *ngIf="isSameVendor(item)"> {{ 0 | currency: item?.product_variant.product?.vendor?.currency:'symbol' }} (Own Product)</span>
                            </td>
                            <td>
                                <a *ngIf="!deleteProcessing" href="javascript:void(0)" (click)="onDeleteItem(item)" class="cancel-icon">
                                    <i class="fa fa-times" *ngIf="!item.loading"></i>
                                    <app-preloader *ngIf="item.loading" [size]="'sm'"></app-preloader>
                                </a>
                            </td>
                        </tr>
                            <tr class="custom-finish" *ngIf="item.custom_finish">
                                <td>
                                    <img [src]="item.custom_finish.image | imagePath" [alt]="item.custom_finish.finish_name" class="img-fluid" style="width:150px"/>
                                </td>
                                <td> 
                                    <h3>
                                        <span>Custom Finish:</span> {{ item.custom_finish.finish_name }}
                                    </h3>
                                </td>
                                <td *ngIf="is_hide_cost == null">
                                    {{ item.custom_finish_price | currency: item?.product_variant.product?.vendor?.currency:'symbol' }}
                                </td>
                                <td>
                                    {{ item.quantity }}
                                </td>
                                <td>
                                    {{ item.custom_finish_price*item.quantity | currency: item?.product_variant.product?.vendor?.currency:'symbol' }}
                                </td>
                                <td> </td>
                              </tr>
                        </ng-container>
                        <tr *ngFor="let addonItem of cartData.addons">
                            <td>
                                <img [src]="addonItem.addon.image_1 | imagePath" [alt]="addonItem.addon.title" class="img-fluid" style="width:150px" />
                            </td>
                            <td style="width: 30%">
                                <h2>
                                    {{ addonItem.addon.title }}
                                </h2>
                                <h3 *ngFor="let spec of helperService.categoryFieldsMapping(addonItem.addon?.category?.slug)">
                                    <ng-template [ngIf]="addonItem.addon[spec]">
                                      <span>{{ trans[spec] }}:</span> {{ addonItem.addon[spec] }}
                                    </ng-template>
                                </h3>
                                <h3>
                                    <span>Part Number: </span> {{ addonItem.addon?.part_number }}
                                </h3>
                            </td>
                            <td *ngIf="is_hide_cost == null">
                                <p>
                                    {{ addonItem.unit_price | currency: ' $ '}}
                                </p>
                            </td>
                            <td>
                                <div class="quinty-box" *ngFor="let warehouseQty of addonItem.warehouse_quantity">
                                    <p>{{ warehouseQty.ware_house.warehouse_name }}</p>
                                    <div class="input-group custom-adder custom-adder-rw">
                                        <input type="button" value="-" class="button-minus" data-field="quantity" (click)="onChangeWarehouseQuantity(addonItem.cart_id, warehouseQty, 'minus')">
                                        <input type="number" step="1" min="1" [value]="warehouseQty.quantity" name="quantity" class="quantity-field">
                                        <input type="button" value="+" class="button-plus" data-field="quantity" (click)="onChangeWarehouseQuantity(addonItem.cart_id, warehouseQty, 'plus')">
                                    </div>
                                </div>
                            </td>
                            <td *ngIf="is_hide_cost == null">
                                {{ addonItem.total_price | currency: ' $ '}}
                            </td>
                            <td *ngIf="is_hide_cost != null">
                                {{ getTotal(addonItem.unit_price, addonItem.discount, addonItem.quantity) | currency: ' $ '}}
                            </td>
                            <td>
                                <a *ngIf="!deleteProcessing" href="javascript:void(0)" (click)="addonDeleteItem(addonItem)" class="cancel-icon">
                                    <i class="fa fa-times" *ngIf="!addonItem.loading"></i>
                                    <app-preloader *ngIf="addonItem.loading" [size]="'sm'"></app-preloader>
                                </a>
                            </td>
                        </tr>
                    </ng-template>
                </table>
            </div>
        </div>
    </div>
    
    <div class="row mt-3" *ngIf="hasCostPerWheel()">
        <div class="col-md-10">
            <h3 class="small-30 new-font">Bolt pattern & Offset Drilling</h3>
        </div>
        <div class="col-md-12">
            <div class="table-responsive">
                <table class="table w-100 cart-table table-bordered">
                    <tr class="bg-row">
                        <td>
                            Name
                        </td>
                        <td>
                            Price
                        </td>
                        <td>
                            Quantity
                        </td>
                        <td colspan="2">
                            Total
                        </td>
                    </tr>
                    <ng-template [ngIf]="cartData">
                        <ng-container *ngFor="let item of cartData.cart_items">
                            <tr *ngIf="item.cost_per_wheel">
                                <td> 
                                    <h3 *ngIf="item.bolt_pattern">
                                        <span>Bolt Pattern: </span>{{ item.bolt_pattern == 'recommended' ? 'Recommended' : item.bolt_pattern }}
                                    </h3>
                                    <h3 *ngIf="item.offset">
                                        <span>Offset: </span>{{ item.offset === 'recommended' ? 'Recommended' : item.offset }}
                                    </h3>
                                </td>
                                <td>
                                    {{ item.cost_per_wheel | currency: item?.product_variant.product?.vendor?.currency:'symbol' }}
                                </td>
                                <td>
                                    {{ item.quantity }}
                                </td>
                                <td>
                                    {{ item.cost_per_wheel*item.quantity | currency: item?.product_variant.product?.vendor?.currency:'symbol' }}
                                </td>
                              </tr>
                    </ng-container>
                    </ng-template>
                </table>
            </div>
        </div>
    </div>

    <div class="row mt-3" *ngIf="cartData">
        <div class="col-md-6 text-left">
            <!-- <span class="error" *ngIf="cartData.count < 4">Minimum purchase quantity should be 4.<br/></span> -->
            <a routerLink="/wheels" class="l-link ship-btn new-btn2">Continue Shopping<i class="fa fa-angle-right"></i></a>
        </div>
        <div class="col-md-6 text-right" *ngIf="cartData.count >= 1">
            <a routerLink="/cart/account" class="l-link ship-btn new-btn2" *ngIf="!isLoggedIn">Proceed to checkout<i class="fa fa-angle-right"></i></a>
            <a routerLink="/cart/checkout" class="l-link ship-btn new-btn2" *ngIf="isLoggedIn">Proceed to checkout<i class="fa fa-angle-right"></i></a>

        </div>

        <!-- <div class="col-md-6 text-right" *ngIf="cartData.count < 4">
            <a ng-disabled="cartData.count < 4" class="l-link">Proceed to checkout<i class="fa fa-angle-right"></i></a>
        </div> -->


    </div>
    <div class="row mt-md-5 mt-1" *ngIf="cartData">
        <div class="col-md-6 col-12">
            <!--      <p class="mt-2">Add a note to your order</p>-->
        </div>
        <div class="col-md-3 col-6 text-md-right">
            <p class="mt-2 new-font fm">CART TOTAL</p>
        </div>
        <div class="col-md-3 col-6 text-right">
            <h2 class="total-price mt-0 new-font fsb" *ngIf="is_hide_cost == null">
                {{ getTotalNum(cartData) | currency: '$ ' }}
            </h2>
            <h2 class="total-price mt-0 new-font fsb" *ngIf="is_hide_cost != null">
                {{ getFakeTotal()| currency: '$ ' }}
            </h2>
        </div>
    </div>
</div>
